import React, { useState, useEffect } from "react";
import SimpleFilter from "../../components/Filter/SimpleFilter";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import { fetchAPIData, generateHiddenColumns, copyToClipboard, platformPermissionOptions,createFilterOptions, createSortFieldOptions } from '../../Utils/Common';
import Table from '../../components/Table/Table';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import sharedContext from "../../contexts/shared-context";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import './system.scss';

const kafkaConsumerSchema = require("../../json/kafkaConsumerSchema.json").view;

const SystemKafkaConsumerTabPanel = ({ setNotify }) => {

  const [apiData, setApiData] = useState({});
  const [rowJsonData, setRowJsonData] = useState({});
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('view');  // default to view mode
  const [reload, setReload] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  // get company id from header using sharedcontext
  const globalCompanyId = React.useContext(sharedContext);

  const handleClose = () => {
    setOpen(false);
  };

  const [kafkaConsumer, setKafkaConsumer] = usePersistentStorage("kafkaConsumer", []);

  useEffect(() => {
    setApiData(kafkaConsumer);
  }, []);

  const fieldData = [
    'groupId', 'topicPartition', 'lag'
  ];

  const sortFieldData = [
    // {
    //   field: 'companyId',
    //   label: 'Company ID'
    // },
    {
      field: 'groupId',
      label: 'Group ID'
    },
    {
      field: 'topicPartition',
      label: 'Topic Partition'
    },
    {
      field: 'lag',
      label: 'Lag'
    }
  ];

  const columns = [
    // {
    //     field: 'id',
    //     type: 'number',
    //     headerName: 'ID',
    //     hide: true,
    //     minWidth: 25,
    //     flex: 1,
    //     headerAlign: 'left',
    //     align: 'left',
    // },
    {
      hideable: false,
      field: 'companyId',
      headerName: 'Company ID',
      minWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) => {
        return params.value.toString();
      }
    },
    {
      hideable: false,
      field: 'groupId',
      headerName: 'Group ID',
      minWidth: 450,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <div className="clipboardContent">
                <div style={{ width: '400px' }}>
                  {params.value}
                </div>
                <Tooltip title="Copy to clipboard" arrow placement="right">
                  <IconButton aria-label="copy group ID" onClick={(event) => copyToClipboard(event, params.row.groupId)}>
                    <CopyIcon sx={{ fontSize: 'small' }} />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </>
        )
      }
    },
    {
      hideable: false,
      field: 'topicPartition',
      headerName: 'Topic Partition',
      minWidth: 450,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <div className="clipboardContent">
                <div style={{ width: '400px' }}>
                  {params.value}
                </div>
                <Tooltip title="Copy to clipboard" arrow placement="right">
                  <IconButton aria-label="copy topic" onClick={(event) => copyToClipboard(event, params.row.topicPartition)}>
                    <CopyIcon sx={{ fontSize: 'small' }} />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </>
        )
      }
    },
    {
      hideable: false,
      field: 'lag',
      headerName: 'Lag',
      type: 'number',
      minWidth: 50,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) => {
        return params.value.toString();
      }
    }
  ];

  const viewRowData = (param, event) => {

    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = param.row;

    setRowJsonData(JsonData);
    setMode('view');
    setOpen(true);
  };

  const fetchData = async (apiURL2) => {
    setIsloading(true);
    await fetchAPIData(apiURL2)
      .then((data) => {
        setApiData(data);
        setKafkaConsumer(data);
        // clear the reload false now that data is loaded
        setReload(false);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);

        let message = `Failed to load Kafka consumer lags \n\n ${err.response.statusText} : ${err.response.data.message}`;
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });

        setReload(false);
        setIsloading(false);
      });

  }

  const configUrl = globalCompanyId && globalCompanyId !== "" ? `/api/companies/${globalCompanyId}/events/consumers?` : '/api/companies/events/consumers?';

  return (
    <>
      <div id="filterContainer" >
        <SimpleFilter permission={platformPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={configUrl} fetchData={fetchData} useCompanyId={false} reload={reload} />
      </div>

      <div id="kafkaConsumerContainer">
        <div >
          <Table data={apiData} columns={columns} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
        </div>
      </div>

      <ActionDialog
        open={open}
        mode={mode}
        onClose={handleClose}
        title="Kafka Consumer Information"
        defaultTab='JSON'
        propertiesTabContent={
          <FormDialog
            formId={'kafkaConsumerReportsDialogId'}
            readOnly={true}
            schema={kafkaConsumerSchema}
            formData={rowJsonData}
          />
        }
        jsonDataName="Kafka Consumer Reports"
        JSONTabContent={rowJsonData}
      />

    </>
  );
}

export default SystemKafkaConsumerTabPanel;